import styled, { css } from "styled-components";
import TextFieldProps from "./TextField.types";

const inputBaseStyles = css`
    box-shadow: none;
    max-width: 100%;
    width: 100%;
    background-color: rgba(42, 42, 42, 0);
    border: solid 1px ${(props) => props.theme.colors["white.50"]};
    border-radius: ${(props) => props.theme.elements.form.input.borderRadius};
    color: ${(props) => props.theme.colors["white.50"]};
    height: ${(props) => props.theme.elements.form.input.height};
    font-weight: ${(props) => props.theme.typography.weights[400]};
    font-size: ${(props) => props.theme.elements.form.input.fontSizeText};
    padding: ${(props) => props.theme.elements.form.input.padding};
    ::placeholder {
        color: ${(props) => props.theme.colors["white.50"]};
        opacity: 1; /* Firefox */
    }
`;

export const StyledLabel = styled.label<TextFieldProps>`
    display: inline-flex;
    font-size: ${(props) => props.theme.elements.form.input.fontSizeLabel};
    font-weight: ${(props) => props.theme.typography.weights[400]};
    color: ${(props) => props.theme.colors["white.100"]};
    margin-bottom: 8px;

    ${({ labelType }) =>
        labelType === "frame" &&
        css`
            position: absolute;
            margin-top: -8px;
            margin-left: 6px;
            padding-left: 4px;
            padding-right: 4px;
            background-color: #242424;
            font-size: 9px;
            color: ${(props) => props.theme.colors["white.50"]};
            z-index: 9;
        `};

    ${({ error }) => error && css`
        color: ${(props) => props.theme.colors.error.strong};
    `};
`;

export const SearchIconHolder = styled.div`
    position: absolute;
    display: inline-flex;
    width: 18px;
    height: 18px;
    margin-left: 18px;
    user-select: none;
    pointer-events: none;

    svg {
        color: #bfbfbf;
    }
`;

export const StyledTextField = styled.input<TextFieldProps>`
    ${inputBaseStyles};

    ::-webkit-search-cancel-button {
        -webkit-appearance: none;
    }
`;

export const InputWrapper = styled.div<TextFieldProps>`
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;

    ${StyledTextField} {
        &:hover {
            color: ${(props) => props.theme.colors["white.50"]};
            background-color: ${(props) => props.theme.colors["white.10"]};
        }

        &:focus-within {
            border-color: ${(props) => props.theme.colors.blue.light};
            color: ${(props) => props.theme.colors["white.100"]};
            background-color: ${(props) => props.theme.colors["black.25"]};
            box-shadow: ${(props) => props.theme.colors.blue.light} 0px 0px 0px 1px;
        }
    }

    ${({ variant }) => {
        switch (variant) {
            case "search":
                return css`
                    ${StyledTextField} {
                        height: 50px;
                        border-radius: 4px;
                        padding-left: 52px;

                        ::placeholder {
                            color: #bfbfbf;
                            opacity: 1; /* Firefox */
                        }
                    }

                    &:focus-within {
                        ${SearchIconHolder} > svg {
                            color: ${(props) => props.theme.colors["white.100"]};
                        }
                    }
                `;
            default:
                return null;
        }
    }}

    ${({ error }) =>
        error &&
        css`
            ${StyledTextField} {
                color: ${(props) => props.theme.colors.error.strong} !important;
                border-color: ${(props) => props.theme.colors.error.strong};

                ::placeholder {
                    color: ${(props) => props.theme.colors.error.strong};
                    opacity: 1; /* Firefox */
                }

                &:focus-within {
                    border-color: ${(props) => props.theme.colors.error.strong};
                    box-shadow: ${(props) => props.theme.colors.error.strong} 0px 0px 0px 1px;
                }
            }

            ${SearchIconHolder} > svg {
                color: ${(props) => props.theme.colors.error.strong} !important;
            }
        `}

    ${({ disabled }) =>
        disabled &&
        css`
            ${StyledTextField} {
                color: ${(props) => props.theme.colors["white.25"]};
                border-color: ${(props) => props.theme.colors["white.25"]};
                background-color: rgba(255, 255, 255, 0);
                pointer-events: none;
                user-select: none;
                ::placeholder {
                    color: ${(props) => props.theme.colors["white.25"]};
                    opacity: 1; /* Firefox */
                }
            }

            ${SearchIconHolder} > svg {
                color: ${(props) => props.theme.colors["white.25"]};
            }
        `}
`;
